import { render, staticRenderFns } from "./BatchSummary.vue?vue&type=template&id=47c24b31&"
import script from "./BatchSummary.vue?vue&type=script&lang=ts&"
export * from "./BatchSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports